import React, { FC } from 'react'

import { BorderDecorationTitle } from '@style-port/roov-ui-components-react'

type Props = {
  sizeType?: 's' | 'm' | 'l'
  children: React.ReactNode
  className?: string
}

export const DecorationTitle: FC<Props> = ({ sizeType = 'm', children, className }) => {
  return (
    <div className={className}>
      <BorderDecorationTitle size={sizeType}>{children}</BorderDecorationTitle>
    </div>
  )
}
